import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { pageContext } from 'ctm-util-functions';
import Immutable from 'immutable';
import { resultsConfigSelector } from 'ctm-selectors';
import { BrandLogo, ModalContainer, Text, SimpleFlexbox } from 'ctm-components';

/**
 * Displays a Month to Month Modal Container with link for certain providers that are monthly products
 * @param {Object} state The app state
 * @param {Object} props The component props
 * @returns {MonthToMonth} A MonthToMonth Component
 * @constructor
 */
class _MonthToMonth extends Component {

    constructor(props) {
        super(props);
        this.modalVisualProps = {
            contentVariant: 'padded',
            outerVariant: 'centered',
            containerVariant: 'centered',
            overlayVariant: 'dark'
        };
    }

    /**
     * Don't re-render unless frequency have changed
     * @param {Object} nextProps - The incoming set of props
     * @param {Object} nextState - The incoming component state
     * @returns {Boolean} - True if the component should re-render, false otherwise
     */
    shouldComponentUpdate = (nextProps) => {
        const { frequency } = this.props;
        return nextProps.frequency !== frequency;
    };

    render = () => {
        const { stateProps: { product }, frequency, openComponent } = this.props;
        const providerToShow = null; // Previously ENSU
        const vertical = pageContext.getVertical();
        const brandLogoElementProps = { srcPath: `/evt/assets/images/logos/${vertical}` };
        return (product.getIn(['providerMeta', 'code']) === providerToShow && frequency !== 'annual') ? (
            <ModalContainer stateProps={{ isOpen: false }} openComponent={openComponent} visualProps={this.modalVisualProps}>
                <SimpleFlexbox display="flex">
                    <SimpleFlexbox display="flex" padding="top_small">
                        <BrandLogo
                            stateProps={{ product }}
                            elementProps={brandLogoElementProps} />
                    </SimpleFlexbox>
                    <SimpleFlexbox display="flex" margin="left" column>
                        <h3>{product.getIn(['productMeta', 'name'])}</h3>
                        <h3>Price Disclaimer</h3>
                    </SimpleFlexbox>
                </SimpleFlexbox>
                <Text innerHTML={product.getIn(['productMeta', 'disclaimer'])} />
            </ModalContainer>
        ) : null;
    };

}

_MonthToMonth.propTypes = {
    stateProps: PropTypes.shape({
        product: PropTypes.instanceOf(Immutable.Map)
    }),
    openComponent: PropTypes.array,
    frequency: PropTypes.string
};

_MonthToMonth.defaultProps = {
    stateProps: {
        product: Immutable.Map()
    }
};

const mapStateToProps = (state, props) => {
    const frequency = resultsConfigSelector(state).getIn(['filters', 'frequency']);
    return {
        frequency
    };
};

// connect state to props
const MonthToMonth = connect(mapStateToProps)(_MonthToMonth);

export { MonthToMonth };
